import CpfValidation from './CpfValidation';

export default CpfValidation;
